<div class="flex flex-col gap-5 flex-1 h-full">
  <mat-card style="padding: 10px 24px">
    <div class="flex justify-between content-center items-center w-full flex-row">
      <div class="flex justify-between content-center items-center h-full flex-row gap-[5px]">
        <button class="button button--primary" data-test-id="results-display-continue" (click)="onContinue.emit()">
          Continue
        </button>
      </div>
    </div>
  </mat-card>

  <mat-card class="flex flex-col basis-full">
    <mat-table class="ct-search-table basis-full" [dataSource]="dataSource">
      <ng-container matColumnDef="affiliation">
        <mat-header-cell *matHeaderCellDef> Affiliation </mat-header-cell>
        <mat-cell *matCellDef="let expert">
          <ul class="flex flex-row flex-wrap gap-[2.5px]">
            @for (area of expert.source.affiliations; track area) {
              <li>
                <ng-container [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ value: area }"> </ng-container>
              </li>
            }
          </ul>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expertise">
        <mat-header-cell *matHeaderCellDef> Expertise </mat-header-cell>
        <mat-cell *matCellDef="let expert">
          <ul class="flex flex-row flex-wrap gap-[2.5px]">
            @for (area of expert.source.expertise; track area) {
              <li>
                <ng-container [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ value: area }"> </ng-container>
              </li>
            }
          </ul>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef> Role </mat-header-cell>
        <mat-cell *matCellDef="let expert">
          @if (expert.roles) {
            <ul class="flex flex-row flex-wrap gap-[2.5px]">
              @for (area of expert.roles; track area) {
                <li>
                  <ng-container [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ value: area.name }">
                  </ng-container>
                </li>
              }
            </ul>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let expert">
          <ul class="flex flex-row flex-wrap gap-[2.5px]">
            <li>
              <ng-container
                [ngTemplateOutlet]="item"
                [ngTemplateOutletContext]="{ value: expert.source | expertNameSalesMode: maskedMode }"
              >
              </ng-container>
            </li>
          </ul>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let expert">
          <button mat-icon-button data-test-id="results-display-expert-options" [matMenuTriggerFor]="expertOptions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #expertOptions="matMenu">
            <button
              mat-menu-item
              data-test-id="results-display-copy-diagnostic-data"
              style="cursor: copy"
              expert-diagnostic-data
              [expert-context]="expert"
            >
              <span>Copy Diagnostic Data</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="['name', 'affiliation', 'role']; sticky: true"> </mat-header-row>
      <mat-row *matRowDef="let expert; columns: ['name', 'affiliation', 'role']"> </mat-row>
    </mat-table>

    <mat-paginator
      showFirstLastButtons
      data-test-id="results-display-page-size"
      [pageSize]="50"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </mat-card>
</div>

<ng-template #item let-value="value">
  <app-pill size="sm" shape="square" class="cursor-copy" [matTooltip]="value" [copy-clipboard]="value">
    {{ value | ellipsis: 100 }}
  </app-pill>
</ng-template>
